import { tempoApi } from '@/common/api/tempoApi';
import type { ItemDescendantsDetails } from '@/common/api/types/items';

const ITEM_DESCENDANTS_BATCH_LIMIT = 50;

const getItemDescendantsDetailsByIds = async (
  itemIds: Set<number>,
): Promise<Record<number, boolean>> => {
  if (itemIds.size === 0) return {};

  const itemIdsArray = Array.from(itemIds);

  const chunks = itemIdsArray.reduce((acc: number[][], _, index) => {
    if (index % ITEM_DESCENDANTS_BATCH_LIMIT === 0) {
      acc.push(itemIdsArray.slice(index, index + ITEM_DESCENDANTS_BATCH_LIMIT));
    }
    return acc;
  }, []);

  const allResults: Record<number, boolean> = {};
  for (const chunk of chunks) {
    const response = await tempoApi().post(
      'api/v1/item-store/item-descendants/details/by-item-ids',
      {
        json: chunk,
      },
    );
    const result = await response.json<ItemDescendantsDetails[]>();
    const chunkResult = result.reduce<Record<number, boolean>>((acc, item) => {
      acc[item.itemId] = item.hasChildren;
      return acc;
    }, {});
    Object.assign(allResults, chunkResult);
  }

  return allResults;
};

export const ItemDescendantsApi = {
  getItemDescendantsByItemIds: getItemDescendantsDetailsByIds,
};
